import { TOTAL_NON_JP_LANGUAGES } from "@/features/learning-content/constants/language";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Stack, Tooltip, Typography } from "@mui/material";
import { FC } from "react";

type TExplanationLanguageCountCellProps = {
  supportedLanguages: string[];
};

// Displays language count with color coding + info icon with tooltip
// Black text = all languages present (TOTAL_NON_JP_LANGUAGES), red text = incomplete
export const ExplanationLanguageCountCell: FC<TExplanationLanguageCountCellProps> = ({ supportedLanguages }) => {
  const count = supportedLanguages.length;
  const isComplete = count >= TOTAL_NON_JP_LANGUAGES;
  const color = isComplete ? "text.primary" : "error.main";
  const tooltipText = supportedLanguages.join(", ") || "-";

  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      <Typography variant="body14" sx={{ color, fontWeight: 500 }}>
        {count}
      </Typography>
      <Tooltip title={tooltipText} arrow placement="top">
        <InfoOutlinedIcon sx={{ fontSize: 18, color: "text.secondary", cursor: "pointer" }} />
      </Tooltip>
    </Stack>
  );
};
